module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiExt.ea059b7.ttf";